import React, { useEffect } from "react";
import { useState } from "react";
import { getAvatarBase64 } from "../../service/api";

export const useAvatar = () => {
  const [avatarB64, setAvatarB64] = useState(null);
  const getAvatarB64 = async (fresh) => {
    if (avatarB64 && !fresh) return avatarB64;
    try {
      const base64Image = await getAvatarBase64();
      setAvatarB64(base64Image);
      return base64Image;
    } catch (error) {
      setAvatarB64(null);
      console.error(error);
      throw error;
    }
  };

  return { setAvatarB64, getAvatarB64 };
};

const Avatar = ({ base64Image, width, height }) => {
  return (
      <img
        style={{
          width: width? width: "100%",
          height: height? height: "100%",
          borderRadius: "50%",
          objectFit: "cover",
          objectPosition: "center center",
        }}
        src={`${base64Image}`}
        alt="User Avatar"
      />
  );
};

export default Avatar;
